var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-4"},[_c('v-toolbar',{attrs:{"dense":"","dark":"","flat":"","color":"light-blue darken-4","elevation":"10"}},[_c('v-toolbar-title',[_vm._t("default")],2)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-3 mb-2"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }